import { render } from "./GiftcardChristmasWhite.vue?vue&type=template&id=9a5cdf48&scoped=true"
import script from "./GiftcardChristmasWhite.vue?vue&type=script&lang=js"
export * from "./GiftcardChristmasWhite.vue?vue&type=script&lang=js"

import "./GiftcardChristmasWhite.vue?vue&type=style&index=0&id=9a5cdf48&lang=postcss&scoped=true"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a5cdf48"]])

export default __exports__